<template>
  <div>
    <wc-dialog
      :title='value.id ? "Edit details" : "Create New Group"'
      icon='mdi-routes'
      iconColor='black'
      :showDialog='showDialog'
      :disableButtons='!isFormValid'
      :loadingButtons='isLoading'
      :loading='isLoading'
      @cancel="cancel"
      @save='update'
    >

      <v-form :disabled='isLoading' v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12'>
            <v-text-field
              label='Group Letter'
              v-model='value.route_group'
              :rules="value.id ? [] : [rules.required, rules.unused, rules.uppercase]"
              maxlength='2'
              counter
              :hint='letterHint'
              persistent-hint
              :disabled='!!value.id'
            ></v-text-field>
          </v-col>

          <v-col cols='12'>
            <v-text-field
              label='Description'
              v-model='value.description'
              :hint='isLawnDivision ? "Day of Week, followed by Geographic Label (eg. Monday - Terwillegar)" : "General Geographic Area? (eg. Millwoods, Sherwood Park... etc)"'
              persistent-hint
              maxlength='32'
              counter
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

      <template v-slot:dialog-actions>
        <v-tooltip top :disabled='!groupHasProjects'>
          <template v-slot:activator='{ on }'>
            <div v-on='on' class='d-inline-block'>
              <v-btn text :disabled='groupHasProjects' color='red' @click='confirmDeleteGroup = true'>Delete Group</v-btn>
            </div>
          </template>
          <span>You cannot delete a group that contains projects</span>
        </v-tooltip>
      </template>
    </wc-dialog>

    <wc-confirm
      :showDialog='confirmDeleteGroup'
      @cancel='confirmDeleteGroup = false'
      @confirm='deleteGroup'
    >
      Delete this group?
      <br>
      <br>
      {{ value.route_group }} - {{ value.description ? value.description : "(no description)" }}
    </wc-confirm>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name:'group-details-dialog',
  props: {
    showDialog: {
      required: true
    },
    value: {
      required: true
    },
    isLoading: {
      required: true
    },
    usedLetters: {
      required: true
    }
  },
  data: () => ({
    isFormValid: false,
    confirmDeleteGroup: false,
  }),
  computed: {
    rules() {
      return {
        required: value => !!value || 'Required.',
        unused: value => !_.includes(this.usedLetters, value) || 'Already used.',
        uppercase: (value) => {
          const pattern = /^[A-Z]{1,2}$/
          return pattern.test(value) || 'Must be uppercase'
        }
      }
    },
    letterHint () {
      if (this.isLawnDivision) {
        return "One or two letters. Please note: This won't necessarily be same as irrigation routing"
      }
      return this.value.id ? "currently cannot be edited once set" : "one or two letters"
    },
    groupHasProjects () {
      if (this.value && this.value.projects && this.value.unrouted) {
        return this.value.projects.length > 0 || this.value.unrouted.length > 0
      }
      return true
    },
    isLawnDivision () {
      return this.value.division === _.find(this.$store.state.misc.divisions, d => d.division === 'Lawn').id
    }
  },
  methods: {
    update () {
      this.$emit('update')
    },
    cancel () {
      this.$emit('cancel')
    },
    resetValidate () {
      console.log('reset validation called')
      setTimeout(() => {
        this.$refs.form.resetValidation()
      }, 100)
    },
    deleteGroup () {
      this.$emit('deleteGroup')
      this.confirmDeleteGroup = false
    }
  }
}
</script>